export default __webpack_public_path__ + "static/media/balance-sheet.63214908.png";